<div class="collapse-expand-button">
    <span *ngIf="isOpen">-</span>
    <span *ngIf="!isOpen">+</span>
</div>